export type FitMode = "contain" | "cover";

export type DevicePrefs = {
  micId?: string;
  speakerId?: string;
  cameraId?: string;
  micMuted?: boolean;
  videoOn?: boolean;

  remoteFitMode?: FitMode;
  pipFitMode?: FitMode;

  // receiver-side remote view controls
  remoteZoom?: number;  // 1..3
  remotePanX?: number;  // px
  remotePanY?: number;  // px
};

const KEY = "telehealth_device_prefs_v1";
const EVT = "telehealth:prefs";

export function loadDevicePrefs(): DevicePrefs {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? (JSON.parse(raw) as DevicePrefs) : {};
    return {
      remoteFitMode: "contain",
      pipFitMode: "cover",
      remoteZoom: 1,
      remotePanX: 0,
      remotePanY: 0,
      ...parsed,
    };
  } catch {
    return { remoteFitMode: "contain", pipFitMode: "cover", remoteZoom: 1, remotePanX: 0, remotePanY: 0 };
  }
}

export function saveDevicePrefs(partial: Partial<DevicePrefs>) {
  const current = loadDevicePrefs();
  localStorage.setItem(KEY, JSON.stringify({ ...current, ...partial }));

  // notify same-tab listeners (Consult)
  try {
    window.dispatchEvent(new CustomEvent(EVT));
  } catch {}
}

export const devicePrefsEventName = EVT;
